import styled from "styled-components";
import { darkColorString, lightColorString } from "../../util/theme";

export const Highlight = styled.span`
  background-color: ${darkColorString};
  color: ${lightColorString};
`;
